var React = require('react');

function Ellipsis (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface65502428"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(100%,100%,100%)","fillOpacity":"1"},"d":"M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z M 42 20 "})));
}

Ellipsis.defaultProps = {"viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = Ellipsis;

Ellipsis.default = Ellipsis;
